import { Box, useTheme } from "@chakra-ui/react";
import { IReactionBarSegment } from "src/components/common/aggregated-reactions-bar/types";
import { getBarColorHex } from "src/components/common/aggregated-reactions-bar/utils/get-bar-color-hex";
import { AGGREGATED_REACTIONS_BAR_SEGMENT_TEST_ID } from "./reaction-bar-segment.test-ids";

export interface IReactionBarSegmentProps extends Omit<IReactionBarSegment, "value" | "weightedValue"> {
    width: number;
}

export const ReactionBarSegment = ({ width, color }: IReactionBarSegmentProps) => {
    const theme = useTheme();
    const barColor = getBarColorHex(color, theme);

    return (
        <Box
            h="100%"
            w={`${width}%`}
            transition="width .2s ease-out"
            minWidth={1}
            backgroundColor={barColor}
            whiteSpace="nowrap"
            data-test-id={AGGREGATED_REACTIONS_BAR_SEGMENT_TEST_ID}
        />
    );
};
